import React, { SVGProps } from 'react';

const DefaultIntegerIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect
        x="2.49683"
        y="2.49689"
        width="15.0062"
        height="15.0062"
        rx="2.5"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.14575 12.5833H6.14575H7.64575V7.58331L6.14575 8.83331"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.1458 7.58331H13.873V9.58331L11.1458 11.0833V12.5833H14.1458"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default DefaultIntegerIcon;
